$shm_wordstat_region_select $mol_view
	regions? \
	search? \
	error_text? \
	tree null
	allowed_ids /
	presets_visible true
	select_all_visible false
	only_visible false
	sub <= section_rows /
	Title $mol_view
		sub <= title_content /
			<= Title_line $mol_view
				sub <= title_line_content /
					<= Label $mol_view
						sub / \Регионы
					<= Select_all $shm_check_all
						checks <= select_all_checks /
						title \Все
			<= Summary $mol_view
				sub /
					<= summary \Весь мир
	Content $mol_view
		sub /
			<= Presets $mol_view
				sub <= presets_content /
					<= Preset_actions $mol_view
						sub /
							<= Preset_reset $mol_button_minor
								title \Сбросить
								click? <=> preset_reset? null
							<= Preset_districts $mol_check
								title \По округам
								checked? <=> preset_districts_checked? false
								style *
									^
									color <= preset_districts_color \
							<= Preset_areas $mol_check
								title \По областям
								checked? <=> preset_areas_checked? false
								style *
									^
									color <= preset_areas_color \
			<= Search $mol_string
				hint \Поиск региона
				value? <=> search?
			<= Tree $mol_view
				sub <= tree_content /
	Empty $mol_view
		sub /
			\Регионов не найдено
	Error $mol_view
		sub /
			<= error_text? \
	Preset_collapse $mol_button_minor
		title \Свернуть все
		click? <=> collapse_all? null
	Node* $mol_view
		sub <= node_rows* /
	Row* $mol_view
		sub /
			<= Row_expand* $mol_check_expand
				checked? <=> node_expanded*? false
				expandable <= node_expandable* true
			<= Row_content* $mol_view
				sub <= row_content* /
					<= Row_check* $mol_check_box
						checked? <=> row_checked*? false
						title <= row_title* \
					<= Row_only* $mol_button_minor
						title \Только
						click? <=> row_only*? null
					<= Row_label* $mol_view
						sub /
							<= row_title* \
					<= Row_collapse* $mol_button_minor
						title \Свернуть все
						click? <=> collapse_all? null
	Children* $mol_view
		sub <= node_children* /
